module.exports = __webpack_public_path__ + "img/Qualificacao_ao_Cuidado_do_Idoso.bc86c62e.jpg";